export default __webpack_public_path__ + "static/media/mainBCMobile.2bffdd4d.png";